import React from "react";
import "./styles.css";

export default function Button(props) {
	return (
		<button style={props.style} className={`button ${props.primary ? "primary" : ""}	`} type={props.type} onClick={props.onClick}>
			<span>{props.children}</span>
		</button>
	);
}